"use client";

import { Button } from "@relume_io/relume-ui";
import React from "react";
import backgroundImage from '../../assets/images/BG1.jpg';
import ContactButton from "../../components/shared/ContactButton";

export function ServiceBanner() {
  return (
    <section className="px-[5%] py-16 md:py-24 lg:py-24 max-h-[900px] bg-[rgba(0,0,0,0.5)] h-50dvh text-white ">
      <div className="container flex justify-center container md:max-w-5xl lg:max-w-7xl mx-auto">
        <div className="flex flex-col gap-5 md:gap-10 lg:gap-10 drop-shadow-2xl">
          <div className="">
            {/* <p className="mb-3 font-semibold md:mb-4">Services</p> */}
            <h1 className="font-noto font-bold text-5xl leading-14 md:text-5xl lg:leading-16 break-all-mobile">
            Unsere Cybersicherheitsdienstleistungen: Umfassender Schutz für Ihr Unternehmen</h1>
          </div>
          <div className="max-w-4xl">
            <p className="md:text-xl md:backdrop-blur-[2px]">
            Entdecken Sie unsere maßgeschneiderten Cybersicherheitsdienstleistungen, die Ihr Unternehmen vor digitalen Bedrohungen schützen. Von Sicherheitsbewertungen bis hin zu kontinuierlichem Monitoring bieten wir Lösungen für Ihre Sicherheit.
            </p>
            <div className="mt-6 flex flex-wrap gap-4 md:mt-8">
           <ContactButton/>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

